import { render } from "./PositivePay.vue?vue&type=template&id=035a5f18&scoped=true"
import script from "./PositivePay.vue?vue&type=script&lang=js"
export * from "./PositivePay.vue?vue&type=script&lang=js"

import "./PositivePay.vue?vue&type=style&index=0&id=035a5f18&scoped=true&lang=css"
import "./PositivePay.vue?vue&type=style&index=1&id=035a5f18&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035a5f18"]])

export default __exports__